(function () {
  function init() {
    document.querySelectorAll('[data-sml-slider]').forEach(function (sl) {
      if (sl._smInit) return;
      sl._smInit = true;

      var track = sl.querySelector('[data-sml-track]');
      var root = sl.parentElement;
      var prevBtn = root.querySelector('[data-sml-prev]');
      var nextBtn = root.querySelector('[data-sml-next]');
      if (!track) return;

      function getStep() {
        var card = track.querySelector('.sml-pricing__card');
        if (!card) return track.clientWidth;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function updateNav() {
        if (!prevBtn || !nextBtn) return;
        var max = track.scrollWidth - track.clientWidth - 1;
        prevBtn.toggleAttribute('disabled', track.scrollLeft <= 0);
        nextBtn.toggleAttribute('disabled', track.scrollLeft >= max);
      }
      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();

      if (prevBtn) prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.querySelectorAll('img').forEach(function (img) { img.setAttribute('draggable', 'false'); });

      var isDown = false;
      var startX = 0;
      var startScroll = 0;
      var moved = false;

      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        if (e.target.closest('button, input, select, textarea, label, [role="button"]')) return;
        var closestA = e.target.closest('a');
        if (closestA && !closestA.classList.contains('sml-pricing__card')) return;
        isDown = true;
        moved = false;
        startX = e.pageX - track.offsetLeft;
        startScroll = track.scrollLeft;
        e.preventDefault();
      });

      document.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var x = e.pageX - track.offsetLeft;
        var walk = (x - startX) * 1.5;
        if (Math.abs(walk) > 4) {
          if (!moved) track.classList.add('is-dragging');
          moved = true;
          e.preventDefault();
          track.scrollLeft = startScroll - walk;
        }
      });

      document.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
      });

      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
